import { render } from "./ModuleManagement.vue?vue&type=template&id=049ac18b&scoped=true"
import script from "./ModuleManagement.vue?vue&type=script&lang=js"
export * from "./ModuleManagement.vue?vue&type=script&lang=js"

import "./ModuleManagement.vue?vue&type=style&index=0&id=049ac18b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-049ac18b"

export default script